var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { Popper } from 'react-popper';
import styled from 'styled-components';
import Arrow from './Arrow';
import StyledPopover from './Popover';
import popoverTheme from './theme';
import { ComponentThemeProvider } from '../ThemeProvider';
var ContentWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n  background-color: white;\n  border-radius: ", ";\n"], ["\n  overflow: hidden;\n  background-color: white;\n  border-radius: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.popover.borderRadius;
});
/**
 * Popover component that handles the position and attachment to a target
 * component through a react reference
 */
export var Popover = function (_a) {
    var children = _a.children, target = _a.target, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, className = _a.className;
    var getPlacement = function () {
        if (top) {
            return 'top';
        }
        if (left) {
            return 'left';
        }
        if (right) {
            return 'right';
        }
        // Default value is bottom
        return 'bottom';
    };
    return (React.createElement(ComponentThemeProvider, { theme: popoverTheme },
        React.createElement(Popper, { placement: getPlacement(), referenceElement: target }, function (_a) {
            var arrowProps = _a.arrowProps, placement = _a.placement, ref = _a.ref, style = _a.style;
            return (React.createElement(StyledPopover, { className: className, ref: ref, style: style },
                React.createElement(ContentWrapper, null, children),
                React.createElement(Arrow, { "data-placement": placement, ref: arrowProps.ref, style: arrowProps.style })));
        })));
};
export default Popover;
var templateObject_1;
//# sourceMappingURL=index.js.map